import { createAction } from '@reduxjs/toolkit';

export const changeSystemStatus = createAction<{
  isSystemDown: boolean;
  restoreDate: string;
}>('CHANGE_SYSTEM_STATUS');

export const byPassMaintenanceMode = createAction<boolean>(
  'BY_PASS_MAINTENANCE_MODE',
);
